<template>
	<div>
		<div v-if="!loading && !autoload && !loaded">
			<button v-on:click="load()">Load</button>
		</div>
		<div v-if="loading">
			<Loader />
		</div>
		<div v-if="loaded && !loading">

			<div class="flex align-items margin-bottom small-padding-bottom">
				<div class="flex flex-grow">
					<Flag :localeid="locale.locale_id" size="42" />
					<div class="small-margin-left">
						<h1>{{ displayName }} (#{{ id }})</h1>
					</div>
				</div>
				<div class="text-right flex-grow">
					<div style="position: relative;">
						<button
							class="small-margin-left"
							v-on:click="$refs.dropdown.toggle()">...</button>

						<div style="text-align: left; position: relative; right: 100px">
							<CustomerDropdown ref="dropdown" :id="id" />
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="deleted"
				class="error margin-top margin-bottom small-padding"
				style="background: #ff5555">
				<span class="white">User account is deleted</span>
			</div>

			<template>
				<Tabs :tabs="tabs" v-model="active_tab" v-on:change="tabChange" class="margin-top large-margin-bottom" />

				<div v-if="active_tab == 'discounts'">
					<CustomerDiscountScheduler :id="id" />
				</div>

        <div v-if="active_tab === 'wallet'">
          <Wallet
            :id="id"
            />
        </div>

				<div v-show="active_tab == 'general'">

					<Grid>
						<div>
							<strong>Email:</strong>
							<a :href="'mailto:' + email">{{ email }}</a>
							<div class="small-margin-top">
								<button :disabled="saving" v-on:click="updateBasicInfo('email');">Change</button>
							</div>
						</div>
						<div>
							<strong>Phone:</strong>
							{{ phone }}
							<div class="small-margin-top">
								<button :disabled="saving" v-on:click="updateBasicInfo('phone');">Change</button>
							</div>
						</div>
					</Grid>

					<Grid>
						<div v-for="(attribute, id) in attributes">
							<h3>{{ humanReadableAttribute(id) }}</h3>
							<input min="42" max="56" step="2" class="text-center small-margin-bottom" type="number" style="width: 50px;" v-model="attributes[id]" />
							<br />
							<button class="light" :disabled="updatingMeta" v-on:click="updateMeta(id, attributes[id]);">Save</button>
						</div>
					</Grid>

					<Grid>
						<div>
							<h3>Klaviyo profile ID</h3>
							{{ klaviyo_profile_id }}
						</div>
						<div>
							<h3>Klaviyo last updated</h3>
							{{ klaviyo.last_updated ? klaviyo.last_updated : 'N/A' }}
						</div>
						<div>
							<h3>Klaviyo last checked</h3>
							{{ klaviyo.last_checked ? klaviyo.last_checked : 'N/A' }}
						</div>
					</Grid>

				<div class="flex margin-top">
					<div class="flex-basis">
						<Group
							class="margin-right"
							title="Name">
							<div class="flex margin-bottom">
								<MaterialText
									class="medium small-margin-right"
									label="First name"
									v-model="name.first" />

								<MaterialText
									class="medium"
									label="Last name"
									v-model="name.last" />
							</div>

							<button
								v-on:click="updateName"
								:disabled="saving">Save</button>
						</Group>
					</div>
					<div class="flex-basis">
						<Group title="Locale">
							<MaterialDropdown :options="locales" v-model="locale_id" />
							<div class="margin-top">
								<button :disabled="saving" v-on:click="save()">Save</button>
							</div>
						</Group>
					</div>
				</div>

          <Group title="Customer comments" class="margin-top">
            <p>
              The comment system coupled with ChatGPT and the front-end where customers can enter new comments.
            </p>
            <div v-if="data.customer_comments.length === 0" class="margin-bottom">
              <em>No comments added</em>
            </div>
            <div v-for="comment in data.customer_comments" class="margin-bottom border padding">
              {{ comment.comment }}
              <div class="small-margin-top">
                <div>
                  <strong>Source:</strong>
                  {{ comment.source }}
                </div>
                <div>
                  <strong>Order:</strong>
                  <OrderLink
                    :id="comment.order_id"
                    v-if="comment.order_id"
                    />
                  <span v-else>N/A</span>
                </div>
                <div>
                  <strong>Processed at:</strong>
                  <Format type="date" :time="true" v-if="comment.processed_at" />
                  <span v-else>N/A</span>
                </div>
                <div>
                  <strong>Failed at:</strong>
                  <Format type="date" :time="true" v-if="comment.failed_at" />
                  <span v-else>N/A</span>
                </div>
              </div>
            </div>

            <div class="margin-top">
              <h2>Add comment</h2>
              <textarea
                class="small-margin-top"
                style="width: 500px; height: 140px;"
                v-model="comment_form.comment"></textarea>
              <MaterialText
                class="margin-top"
                label="Order no."
                v-model="comment_form.order_id" />
              <MaterialDropdown
                class="margin-top"
                label="Source"
                v-model="comment_form.source"
                :options="{
                  sp_wish: 'sp_wish',
                  sp_few_likes: 'sp_few_likes',
                  sp_missing_in_box: 'sp_missing_in_box',
                  return_feedback: 'return_feedback',
                  customer_care: 'customer_care',
                  old_stylist_comment: 'old_stylist_comment'
                }"/>

              <button
                class="margin-top"
                v-on:click="submitComment"
                :disabled="saving">Submit</button>
            </div>
          </Group>

					<Group title="Comments (Old?)" class="margin-top">
						<div v-for="comment in order_comments" class="margin-bottom border">
							<div class="flex">
								<div class="flex-basis small-padding">
									<div><strong>Date</strong></div>
									<Format type="date" :time="true" :value="comment.created_at" />
								</div>
								<div class="flex-basis small-padding">
									<div>
										<strong>Order</strong>
									</div>
									<OrderLink :id="comment.order_id" />
								</div>
								<div class="flex-basis small-padding">
									<div v-for="user in getUsers" v-if="user.id == comment.user_id">
										<div>
											<strong>By</strong>
										</div>
										{{ user.shortened_name }}
									</div>
								</div>
							</div>
							<div class="small-padding border-top">
								{{ comment.comment }}
							</div>
						</div>
					</Group>

					<Group title="Settings" class="margin-top">
						<MaterialNumber :disabled="saving" v-model="settings.styling_deposit" class="short" label="Deposit" v-on:enter="updateSettings()" />
						<div class="note small-margin-top">
							Only applicable if customer hasn't already ordered their subscription
						</div>
						<div class="margin-top border-top padding-top">
							<button
								:disabled="saving"
								v-on:click="deleteUser"
								class="danger">Delete customer's account</button>
						</div>
					</Group>

				</div>

				<div v-show="active_tab == 'attributes'">
					<div v-for="(attribute, a) in customer_attributes">
						<MaterialToggle v-model="customer_attributes[a]" :label="a" />
					</div>
					<div class="margin-top">
						<button :disabled="saving" v-on:click="saveAttributes()">Save attributes</button>
					</div>
				</div>

				<div v-if="active_tab == 'history'">
					<CustomerHistory :id="id" />
				</div>

				<div v-show="active_tab == 'klaviyo'">
					<CustomerKlaviyo ref="klaviyo" :id="id" />
				</div>

				<div v-show="active_tab == 'subscription'">
					<Subscription :customer="this.id" />
				</div>

				<div v-show="active_tab == 'payment_methods'">
					<Group title="Stripe key">
						<div class="flex">
							<MaterialText label="Stripe key" v-model="stripe_key" />
							<div class="margin-left">
								<button :disabled="saving" v-on:click="saveStripeKey()">Save</button>
							</div>
						</div>
					</Group>
					<Group title="Credit cards" class="margin-top">
						<CustomerPaymentMethods :id="id" />
					</Group>
				</div>

				<div v-if="active_tab == 'orders'">
					<CustomerOrders :id="id" />
				</div>

				<div class="margin-top" v-show="active_tab == 'comments'">
					<div class="border-top">
						<div v-for="comment in stylistComments" class="small-padding-top small-padding-bottom border-bottom">
							<template v-if="editingComment == comment.id">
								<textarea v-model="comment.comment" cols="80" rows="6"></textarea>
								<div class="small-padding-top">
									<button :disabled="savingComment" v-on:click="saveComment(comment.id)" class="small-margin-right">Save</button>
									<button v-on:click="editingComment = false; comment.comment = originalComment; originalComment = '';" class="light">Cancel</button>
								</div>
							</template>
							<template v-else>
								{{ comment.comment ? comment.comment : '[Empty]' }}
								<div class="small-padding-top">
									<button v-on:click="originalComment = comment.comment; editingComment = comment.id">Edit</button>
								</div>
							</template>
						</div>
					</div>
					<button class="small-margin-top" v-on:click="addComment();">+ New comment</button>
				</div>

				<div class="margin-top" v-show="active_tab == 'events'">
					<EventViewer :resource="'~customer:' + id" />
				</div>

				<div class="margin-top" v-show="active_tab == 'email_history'">
					<EmailHistory resource="customer" :id="id" />
				</div>

				<div class="margin-top" v-show="active_tab == 'shipping'">
					<CustomerShippingEditor :autoload="true" :id="id" />
				</div>

			</template>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import EventViewer from '@/components/EventViewer.vue'
import CustomerShippingEditor from '@/components/CustomerShippingEditor.vue'
import CustomerKlaviyo from '@/components/CustomerKlaviyo.vue'
import CustomerPaymentMethods from '@/components/CustomerPaymentMethods.vue'
import CustomerHistory from '@/components/CustomerHistory.vue'
import CustomerDiscountScheduler from '@/components/CustomerDiscountScheduler.vue'
import CustomerDropdown from '@/components/CustomerDropdown.vue'
import Wallet from '@/components/customer/Wallet.vue'

export default {
  props: [
    'id',
    'autoload'
  ],
  components: {
    Wallet,
    EventViewer,
    CustomerShippingEditor,
    CustomerKlaviyo,
    CustomerPaymentMethods,
    CustomerHistory,
    CustomerDiscountScheduler,
    CustomerDropdown
  },
  data: () => ({
    tabs: {
      general: {
        name: 'General'
      },
      history: {
        name: 'History'
      },
      subscription: {
        name: 'Subscription'
      },
      orders: {
        name: 'Orders'
      },
      wallet: {
        name: 'Wallet'
      },
      discounts: {
        name: 'Discounts'
      },
      email_history: {
        name: 'Communication'
      },
      shipping: {
        name: 'Shipping'
      },
      payment_methods: {
        name: 'Payment'
      },
      comments: {
        name: 'Comments'
      },
      attributes: {
        name: 'Attributes'
      },
      klaviyo: {
        name: 'Klaviyo'
      }
    },
    data: {},
    comment_form: {},
    deleted: false,
    edit_discount: false,
    customer_attributes: {},
    customer_id: null,
    active_tab: 'general',
    locale: {},
    locale_id: false,
    saving: false,
    updatingMeta: false,
    attributes: {},
    savingComment: false,
    settings: {},
    editingComment: false,
    originaComment: '',
    updatingNextBox: false,
    reactivatingSubscription: false,
    editNextBox: false,
    call_booking_key: '',
    loading: false,
    sendingInvoice: false,
    rebuilding: false,
    cancellingSubscription: false,
    stripeLink: '',
    stripe_key: '',
    displayName: '',
    email: '',
    phone: '',
    nextBoxDate: '',
    call_booking_url: '',
    order_comments: [],
    orders: [],
    stylistComments: [],
    failedPayments: {},
    klaviyo: {},
    name: {}
  }),
  computed: {
    ...mapGetters([
      'getLocales',
      'getUsers'
    ]),
    locales () {
      return Vue.$array.keyValue(this.getLocales, 'id', 'locale')
    },
    loaded () {
      return !!this.email
    },
    klaviyo_profile_id () {
      return this.klaviyo.id ? this.klaviyo.id : 'N/A'
    },
    updateNextBoxIsValid () {
      return this.nextBoxDate.match(/^20[0-9]{2}\-(10|11|12|0[0-9])\-((0|1|2)[0-9]|30|31) ((0|1)[0-9]|20|21|22|23)\:(0|1|2|3|4|5)[0-9]\:(0|1|2|3|4|5)[0-9]$/)
    },
    stylingOrders () {
      return this.filterOrderType('styling')
    },
    webshopOrders () {
      return this.filterOrderType('webshop')
    },
    exchangeOrders () {
      return this.filterOrderType('exchange')
    },
    stylingFeeOrders () {
      return this.filterOrderType('styling-fee')
    },
    otherOrders () {
      return this.filterOrderType(true)
    },
    allOrders () {
      return this.filterOrderType(false)
    },
    subscription () {
      for (var i in this.orders) {
        var order = this.orders[i]
        if (order.post_type == 'shop_subscription') {
          return order
        }
      }
      return false
    },
    failedPaymentsRows () {
      var result = []
      for (var i in this.failedPayments) {
        var failedPayment = this.failedPayments[i]
        if (!failedPayment.charged_at) {
          failedPayment.menu = [{
            name: 'Capture',
            onClick: (row) => {
              this.capture(row.order_id)
            },
            disabled: this.saving
          }]
        }
        result.push(failedPayment)
      }
      return result
    }
  },
  methods: {
    deleteUser () {
      if (!confirm('Are you sure? This is irreversible and will destroy all data about the customer not required to be kept by law')) {
        return
      }

      Vue.$api.delete('/customer/' + this.id, {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    sendResetPassword () {
      Vue.$api.post('/customer/' + this.id + '/send-reset-password', {}, {
        loader: toggle => this.saving = toggle,
        callback: () => alert('Email with instructions sent')
      })
    },
    updateName () {
      Vue.$api.put('/customer/' + this.id + '/name', this.name, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    updateSettings () {
      Vue.$api.put('/customer/' + this.id + '/settings', this.settings, {
        loader: toggle => this.saving = toggle
      })
    },
    submitComment() {
      Vue.$api.post('/customer/' + this.id + '/customer-comment', this.comment_form, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    tabChange (tab) {
      switch (tab.id) {
        case 'klaviyo':
          if (!this.tabs[tab.id].loaded) {
            this.$refs[tab.id].load()

            this.tabs[tab.id].loaded = true
          }
          break
      }
    },
    loggedIn (data) {
      const hostname = location.hostname.replace(/\./g, '_')
      const cookieName = hostname + '_user_id'

      Vue.$cookie.set(cookieName, id, { domain: location.hostname, path: '/' })
      Vue.$cookie.set(cookieName, id, { domain: 'www.' + location.hostname, path: '/' })
    },
    login () {
      Vue.$api.post('/customer/' + this.id + '/login', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.loggedIn(data)
      })
    },
    sendCallBookingLink () {
      Vue.api.post('/customer/' + this.id + '/send-booking-call-email', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => alert('Sent :-)')
      })
    },
    capture (orderId) {
      if (confirm('Capture order ' + orderId + ' now?')) {
        Vue.api.post('/order/' + orderId + '/pay', {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: (response) => {
            console.log(response)
            alert(response.message)
            this.load()
          }
        })
      }
    },
    updateBasicInfo (key) {
      var value = prompt('Choose new ' + key, this[key])
      if (value) {
        var data = {}
        data[key] = value
        Vue.api.patch('/customer/' + this.getId(), {
          data: data
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.load()
        })
      }
    },
    save () {
      Vue.$api.patch('/customer/' + this.getId(), {
        data: {
          locale_id: this.locale_id
        }
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.load()
      })
    },
    addComment () {
      Vue.set(this.stylistComments, Object.keys(this.stylistComments).length, {
        user_id: this.$route.params.id,
        comment: ''
      })
    },
    humanReadableAttribute (attribute) {
      switch (attribute) {
        case 'sizeTop':
          return 'Upper part size'
        case 'sizeDress':
          return 'Dress size'
        case 'sizeBottom':
          return 'Pants size'
        default:
          return attribute
      }
    },
    saveComment (id) {
      for (var i in this.stylistComments) {
        if (this.stylistComments[i].id == id) {
          if (!id) {
            id = '0'
          }
          Vue.api.put('/stylist-comment/' + id, {
            comment: this.stylistComments[i].comment,
            user_id: this.stylistComments[i].user_id
          }, {
            before: () => this.savingComment = true,
            always: () => this.savingComment = false,
            callback: (data) => {
              this.originalComment = ''
              this.editingComment = false
              alert('Comment saved')
              if (id == '0') {
                this.load()
              }
            }
          })
        }
      }
    },
    saveStripeKey () {
      Vue.$api.put('/customer/' + this.id + '/stripe-key', {
        stripe_key: this.stripe_key
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.load()
      })
    },
    updateMeta (key, value) {
      Vue.api.put('/customer/' + this.id + '/meta', {
        key: key,
        value: value
      }, {
        before: () => this.updatingMeta = true,
        always: () => this.updatingMeta = false,
        callback: () => alert('Updated')
      })
    },
    getId () {
      if (this.id) {
        return this.id
      }

      return this.$route.params.id
    },
    filterOrderType (orderType) {
      var result = []
      for (var i in this.orders) {
        var order = this.orders[i]
        if (
          order.orderType == orderType						||
						(orderType === true && ['webshop', 'styling', 'exchange', 'styling-fee'].indexOf(order.orderType) == -1)						||
						!orderType
        ) {
          var shippingLink = 'N/A'
          var returnLink = 'N/A'
          for (var j in order.trackings) {
            var tracking = order.trackings[j]
            var link = {
              type: 'link',
              title: tracking.tracking_number,
              url: tracking.url
            }
            if (tracking.type == 'shipment') {
              shippingLink = link
            } else if (tracking.type == 'return') {
              returnLink = link
            }
          }

          var menu = []
          menu.push({
            name: 'Woocommerce',
            url: `${process.env.VUE_APP_WP_URL}/post.php?post=` + order.ID + '&action=edit'
          })
          menu.push({
            name: 'Show',
            onClick: (row) => this.$router.push('/#/order/' + row.id)
          })
          menu.push({
            name: 'Send invoice',
            onClick: (row) => {
              this.sendInvoice(row.id, row.email)
            },
            disabled: this.sendingInvoice
          })
          menu.push({
            name: 'Rebuild',
            onClick: (row) => {
              this.rebuild(row.id)
            },
            disabled: this.rebuilding
          })

          var styledBy = String(order.stylist)
          if (order.styling_ended) {
            styledBy += (styledBy ? ' on ' : '') + order.styling_ended
          }

          result.push({
            id: {
              type: 'link',
              title: order.ID,
              url: '/#/order/' + order.ID
            },
            status: order.post_status,
            ordertype: order.orderType,
            shipping: shippingLink,
            return: returnLink,
            menu: menu,
            styledBy: styledBy
          })
        }
      }
      return result
    },
    load () {
      Vue.api.get('/customer/' + this.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.handleResponse(data)
      })
    },
    handleResponse (data) {
      this.data = data
      this.customer_id = data.id
      this.name = data.name
      this.displayName = data.displayName
      this.email = data.email
      this.nextBoxDate = data.nextBox
      this.orders = data.orders
      this.stripeLink = data.stripeLink
      this.stylistComments = data.comments
      this.attributes = data.attributes
      this.phone = data.phone
      this.failedPayments = data.failedPayments
      this.locale = data.locale
      this.klaviyo = data.klaviyo
      this.call_booking_key = data.call_booking_key
      this.stripe_key = data.stripe_key
      this.locale_id = data.locale.locale_id
      this.call_booking_url = data.call_booking_url
      this.order_comments = data.order_comments
      this.settings = data.settings
      this.customer_attributes = data.customer_attributes
      this.deleted = data.deleted
    },
    sendInvoice (id) {
      var email = prompt('Please enter recipient', this.customer.email)
      Vue.api.post('/invoice/' + id.title + '/send', {
        email: email
      }, {
        before: () => this.sendingInvoice = true,
        always: () => this.sendingInvoice = false,
        callback: () => alert('Sent')
      })
    },
    rebuild (id) {
      Vue.api.post('/order/' + id + '/uniconta/rebuild', {}, {
        before: () => this.rebuilding = true,
        always: () => this.rebuilding = false,
        callback: () => alert('Order rebuilt in Uniconta')
      })
    },
    saveAttributes () {
      Vue.api.patch('/customer/' + this.id + '/attributes', {
        payload: this.customer_attributes
      }, {
        loader: toggle => this.saving = toggle
      })
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>

<style lang="less" scoped>
	.valid {
		color: green;
	}
	.invalid {
		color: red;
	}
</style>
